import styled from "styled-components";
import { Link } from "react-router-dom";

import Quadrak from "../images/quadrak.jpg";
import Bosque1 from "../images/bosque1.jpg";
import Bosque2 from "../images/bosque2.jpg";
import Solos from "../images/solos.jpg";

const projects = [
  {
    id: "01",
    img: Quadrak,
    title: "Quadra K",
  },
  {
    id: "02",
    img: Bosque1,
    title: "Bosque 1",
  },
  {
    id: "03",
    img: Bosque2,
    title: "Bosque 2",
  },
  {
    id: "04",
    img: Solos,
    title: "Solos",
  },
];

const Container = styled.div`
  padding: 0 80px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 32px;
  }

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

const Section = styled.section`
  margin-top: 40px;
  padding: 28px;

  background-color: #fafafa;

  border: 1px solid #e9e8e8;
  border-radius: 12px;

  @media (max-width: 480px) {
    margin-top: 24px;
    padding: 16px;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 700;

  margin: 0 0 24px;

  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin-bottom: 18px;
  }
`;

const Grid = styled.div`
  display: grid;

  grid-template-columns: repeat(12, 1fr);

  gap: 16px;

  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled(Link)`
  position: relative;

  height: 300px;

  border-radius: 12px;
  overflow: hidden;

  cursor: pointer;

  text-decoration: none;
  color: inherit;

  opacity: 0;
  transform: translateY(40px);

  animation: fadeUp 0.6s ease forwards;
  animation-delay: ${({ $index }) => `${$index * 0.08}s`};

  grid-column: ${({ $index }) => {
    if ($index === 0) return "span 5";
    if ($index === 1) return "span 7";
    if ($index === 2) return "span 7";
    return "span 5";
  }};

  @keyframes fadeUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    height: 240px;
  }

  @media (max-width: 600px) {
    grid-column: span 1;
    height: 220px;
  }

  @media (max-width: 480px) {
    height: 190px;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;

  display: block;

  transition: transform 0.5s ease;

  ${Card}:hover & {
    transform: scale(1.04);
  }
`;

const Overlay = styled.div`
  position: absolute;

  inset: 0;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  padding: 16px;

  box-sizing: border-box;

  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.18),
    transparent 45%
  );

  pointer-events: none;

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const ProjectTitle = styled.h3`
  margin: 0;

  background: #000;
  color: #fff;

  border-radius: 12px;

  padding: 10px 16px;

  font-size: 1rem;
  font-weight: 600;

  line-height: 1;

  @media (max-width: 480px) {
    font-size: 0.85rem;
    padding: 8px 12px;
  }
`;

const ArrowButton = styled.div`
  width: 48px;
  height: 48px;

  border-radius: 50%;

  background: #000;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: transform 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
  }

  ${Card}:hover & {
    transform: translate(3px, -3px);
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;

    svg {
      width: 17px;
      height: 17px;
    }
  }
`;

export default function SuccessCases() {
  return (
    <Container>
      <Section>
        <Title>Obras Gerenciadas</Title>

        <Grid>
          {projects.map((project, index) => (
            <Card
              key={project.id}
              $index={index}
              to="/projects"
              aria-label={`Ver projeto ${project.title}`}
            >
              <ProjectImage
                src={project.img}
                alt={project.title}
              />

              <Overlay>
                <ProjectTitle>
                  {project.title}
                </ProjectTitle>

                <ArrowButton>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M7 17L17 7" />
                    <path d="M7 7H17V17" />
                  </svg>
                </ArrowButton>
              </Overlay>
            </Card>
          ))}
        </Grid>
      </Section>
    </Container>
  );
}